module.exports = __webpack_public_path__ + "img/1.ddf8bc15.jpeg";